/**
 * Normalizes a string for comparison by:
 * - Converting to lowercase
 * - Removing all special characters, whitespace, and punctuation
 * - Keeping only alphanumeric characters (a-z, 0-9)
 * 
 * This ensures robust string matching for answer validation,
 * allowing answers with different formatting to be treated as equal.
 * 
 * @param str - The string to normalize
 * @returns Normalized string containing only lowercase alphanumeric characters
 * 
 * @example
 * normalizeString("Jürgen Hoffmann") // returns "jurgenhoffmann"
 * normalizeString("04:30") // returns "0430"
 * normalizeString("Gift / Engelstrompete") // returns "giftengelstrompete"
 */
export const normalizeString = (str: string): string => {
  return str.toLocaleLowerCase().replace(/[^a-z0-9]/gi, "");
};
